import i18n from 'i18next';
import {Button, getFilePreviewUrl, openDialog, showNotification} from 'platform/components';
import {HStack, Link, Show, VStack} from 'platform/foundation';

import {MouseEvent} from 'react';

import {isNil} from 'ramda';
import {isArray} from 'ramda-adjunct';

import {openFile} from 'shared/web';

import {ICellRendererParams} from '../../types/AgGridTypes';
import {getFileCellRendererIcon} from './utils/getFileCellRendererIcon';

export type FileType = string;

export interface FileCellRendererProps extends ICellRendererParams {
  is: string;
  title: string;
  type: FileType;
  remoteUrl: string;
}

export function FileCellRenderer(props: FileCellRendererProps) {
  const cellValue = props?.value;

  const handleOnClick = (event: MouseEvent, value: any) => {
    event.preventDefault();

    const url = getFilePreviewUrl(value?.remoteUrl);

    if (isNil(url)) {
      showNotification.error();
      return;
    }

    openFile(url);
  };

  if (isArray(cellValue)) {
    const firstValue = cellValue?.[0];

    return (
      <HStack align="center" spacing={2}>
        <Show when={cellValue?.length === 1}>
          <Link
            leftIcon={
              firstValue?.contentType ? getFileCellRendererIcon(firstValue?.contentType) : undefined
            }
            title={firstValue?.title}
            onClick={(event) => handleOnClick(event, firstValue)}
            size="small"
            download
          />
        </Show>

        <Show when={cellValue?.length > 1}>
          <Button
            variant="link"
            leftIcon="view"
            title={i18n.t('page.datagrid.labels.showFiles', {count: cellValue?.length ?? 0})}
            onClick={() =>
              openDialog(
                <VStack spacing={2}>
                  {cellValue?.map((file, index) => (
                    <Link
                      title={file?.title}
                      onClick={(event) => handleOnClick(event, file)}
                      leftIcon={
                        file?.contentType ? getFileCellRendererIcon(file?.contentType) : undefined
                      }
                      size="small"
                      key={file?.id ?? index}
                    />
                  ))}
                </VStack>,
                {title: i18n.t('page.datagrid.labels.allFiles'), size: 'small'}
              )
            }
          />
        </Show>
      </HStack>
    );
  }

  return (
    <Link
      title={cellValue?.title}
      leftIcon={
        cellValue?.contentType ? getFileCellRendererIcon(cellValue?.contentType) : undefined
      }
      onClick={(event) => handleOnClick(event, cellValue)}
      size="small"
      download
    />
  );
}
